var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_170_3183",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 42,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 44C26.6269 44.0033 29.2286 43.4874 31.6555 42.4821C34.0825 41.4768 36.2868 40.0019 38.142 38.142C40.0019 36.2868 41.4768 34.0825 42.4821 31.6555C43.4874 29.2286 44.0033 26.6269 44 24C44.0033 21.3731 43.4874 18.7714 42.4821 16.3445C41.4768 13.9176 40.0019 11.7132 38.142 9.85802C36.2868 7.99818 34.0825 6.52323 31.6555 5.51793C29.2286 4.51263 26.6269 3.99678 24 4.00002C21.3731 3.99678 18.7714 4.51263 16.3445 5.51793C13.9176 6.52323 11.7132 7.99818 9.85802 9.85802C7.99818 11.7132 6.52323 13.9176 5.51793 16.3445C4.51263 18.7714 3.99678 21.3731 4.00002 24C3.99678 26.6269 4.51263 29.2286 5.51793 31.6555C6.52323 34.0825 7.99818 36.2868 9.85802 38.142C11.7132 40.0019 13.9176 41.4768 16.3445 42.4821C18.7714 43.4874 21.3731 44.0033 24 44Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24L22 30L34 18",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_170_3183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H48V48H0V0Z",
    fill: "#32D583"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.8dcd0f2188dcd597d748b241060ccbb7.svg";
export { ForwardRef as ReactComponent };